import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter)

const home: RouteConfig = {
  path: '/home',
  components: { 
    title: () => import ('@/components/TitleBar.vue'),
    default: () => import('@/views/Home.vue') 
  },
  meta: { auth: false }
};

const initial: RouteConfig = { 
  path: '/', 
  redirect: '/home', 
  meta: { auth: false }
};

const routes = [
  home, initial
];

const router = new VueRouter({ mode: 'history', base: '/', routes });

export default router
